export const HYPER_LINK_REGEX = /\[(.+?)]\((.+)\)/g

export const parseHyperlinkText = (rawText: string) => {
  return rawText.replace(HYPER_LINK_REGEX, '$1')
}

export function parseHyperLinkValue(rawText: string) {
  return rawText.replace(HYPER_LINK_REGEX, '$2')
}
